import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const MsalAuthRedirect = () => {
  const query = useQuery();

  useEffect(() => {
    if (window.opener) {
      window.opener.postMessage(
        {
          type: 'io.practist.msal.authRedirect',
          queryParams: Array.from(query.entries()),
        },
        '*',
      );
      window.close();
    }
  }, []);

  return (
    <div
      style={{
        backgroundColor: 'var(--mantine-color-gray-0)',
        width: '100%',
        height: '100%',
      }}
    ></div>
  );
};

export default MsalAuthRedirect;

function useQuery() {
  const { search } = useLocation();
  return new URLSearchParams(search);
}
